import { BoilerAdapter, get_z3k_object_state, HeatingCircuit, OTTemperaturePreference, } from 'z3k-config';
import { mergeThermometer } from '../utils';
import { formatTemp } from 'utils';
import { getTemperatureSensor, temperature_from_state } from 'z3k-parser/lib';
export function isNeedBoiler(need_boiler, hc) {
    if (need_boiler) {
        if (!HeatingCircuit.isBoiler(hc)) {
            return false;
        }
    }
    else {
        if (HeatingCircuit.isBoiler(hc)) {
            return false;
        }
    }
    return true;
}
export function isHeatingCircuitHidden(heating_circuit) {
    if (!heating_circuit) {
        return true;
    }
    if (!HeatingCircuit.isEnabled(heating_circuit)) {
        return true;
    }
    return HeatingCircuit.isHidden(heating_circuit);
}
/**
 * @function
 * Надо показать по какой логике управляется контур
 * Часть формируется из конфигурации, часть из состояния контура
 * 1. Летний режим:
 *          контур выключен, уставка не применяется (без надобности)
 * 2. Внешний термостат:
 *          запросом на тепло управляет внешний источник
 * 3. по погодо-зависимой автоматике (ПЗА):
 *      у нас есть график зависимости t° ТН от t° на улице (на улице -10°, t° ТН 50°)
 *
 * !!---ПЗА может быть добавлена к любому из нижеследующих режимов---!!
 *
 * 4. по теплоносителю (ТН):
 *          смотрим на t° жидкости в контуре
 * 5. по воздуху:
 *          смотрим на температуру воздуха в комнате,
 *              t° ТН требуем максимальной для котла (жарим на все деньги).
 *  6. по воздуху с ПИД:
 *      смотрим на температуру воздуха в комнате,
 *          по ней вычисляем t° ТН в пределах t° диапазона для этого контура
 * @param hc - контур
 * @param hc_state - состояние контура
 * @return
 */
export function getZ3KControlConfig(hc) {
    const is_dhw = HeatingCircuit.isDHW(hc);
    const is_water = HeatingCircuit.isControlByWater(hc);
    const is_air = HeatingCircuit.isAirConsumerMode(hc);
    const is_air_pid = HeatingCircuit.isAirPIDConsumerMode(hc);
    const is_cooling = HeatingCircuit.isCooling(hc);
    const has_pza = HeatingCircuit.hasPZA(hc);
    return {
        is_dhw,
        has_pza,
        is_water,
        is_air,
        is_air_pid,
        is_cooling,
    };
}
export function getZ3KControlState(hc, hc_state) {
    if (hc_state) {
        const summer_mode = HeatingCircuit.isSummerMode(hc_state);
        const external_thermostat = !!hc.external_thermostat || HeatingCircuit.isUseExtThermostat(hc_state);
        const external_thermostat_heat_request = HeatingCircuit.isRequestWarmFromExtThermostat(hc_state);
        return {
            summer_mode,
            external_thermostat,
            external_thermostat_heat_request,
        };
    }
    return {
        summer_mode: false,
        external_thermostat: false,
        external_thermostat_heat_request: false,
    };
}
export function getZ3KHeatingCircuitThermometerState(thermometer_config, z3k_state, is_dhw = false) {
    const { id } = thermometer_config;
    const state = id
        ? get_z3k_object_state(z3k_state, id)
        : null;
    if (!state) {
        return {
            temperature: null,
            format_temp: null,
            work_fine: null,
        };
    }
    const temperature = temperature_from_state(state, is_dhw ? OTTemperaturePreference.DHW : OTTemperaturePreference.WATER);
    const work_fine = 'sensor_ok' in state ? state.sensor_ok : true;
    return {
        temperature: temperature != null && work_fine ? temperature : null,
        format_temp: temperature != null && work_fine ? formatTemp(temperature) : '??',
        work_fine,
    };
}
export function getZ3KHeatingCircuitThermometerConfig(z3k_config, thermometer_id) {
    if (!thermometer_id) {
        return {
            id: null,
            name: null,
        };
    }
    const thermometer = getTemperatureSensor(z3k_config, thermometer_id);
    if (!thermometer) {
        return {
            id: null,
            name: null,
        };
    }
    const { id, name } = thermometer;
    return {
        id,
        name,
    };
}
function getZ3KHeatingCircuitThermometersPairConfig(z3k_config, main_id, reserve_id) {
    return {
        main: getZ3KHeatingCircuitThermometerConfig(z3k_config, main_id),
        reserve: getZ3KHeatingCircuitThermometerConfig(z3k_config, reserve_id),
    };
}
function getZ3KHeatingCircuitThermometersPairState(thermometer_pair_config, z3k_state, is_dhw = false) {
    return {
        main: getZ3KHeatingCircuitThermometerState(thermometer_pair_config.main, z3k_state, is_dhw),
        reserve: getZ3KHeatingCircuitThermometerState(thermometer_pair_config.reserve, z3k_state, is_dhw),
    };
}
/**
 * в контуре ГВС управляющим устройством можно назначить АЦШ.
 * НО! в heating_circuit.state.target_sensor_id будет 0.
 * Нам вручную на этом этапе нужно взять АЦШ, как temp_sensor
 */
function getDHWMainTempSensor(z3k_config, control_devices) {
    return control_devices.find((id) => BoilerAdapter.get.byId(z3k_config, id));
}
export function getZ3KHeatingCircuitThermometersConfig(z3k_config, heating_circuit) {
    const { air_temp_sensor, air_temp_sensor_reserve, water_temp_sensor, water_temp_sensor_reserve, dhw_temp_sensor, dhw_temp_sensor_reserve, control_devices, } = heating_circuit;
    return {
        air: getZ3KHeatingCircuitThermometersPairConfig(z3k_config, air_temp_sensor, air_temp_sensor_reserve),
        water: getZ3KHeatingCircuitThermometersPairConfig(z3k_config, water_temp_sensor, water_temp_sensor_reserve),
        dhw: getZ3KHeatingCircuitThermometersPairConfig(z3k_config, getDHWMainTempSensor(z3k_config, control_devices) ?? dhw_temp_sensor, dhw_temp_sensor_reserve),
    };
}
export function getZ3KHeatingCircuitThermometers(thermomters_config, z3k_state, is_dhw = false) {
    const { air, water, dhw } = thermomters_config;
    const air_state = getZ3KHeatingCircuitThermometersPairState(air, z3k_state, is_dhw);
    const water_state = getZ3KHeatingCircuitThermometersPairState(water, z3k_state, is_dhw);
    const dhw_state = dhw
        ? getZ3KHeatingCircuitThermometersPairState(dhw, z3k_state, is_dhw)
        : undefined;
    return {
        air: mergeThermometer(air, air_state),
        water: mergeThermometer(water, water_state),
        dhw: dhw && dhw_state ? mergeThermometer(dhw, dhw_state) : undefined,
    };
}
